import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";
import whitepaperImg from "@/assets/whitepaper-popup.jpeg";

const STORAGE_KEY = "whitepaper-popup-dismissed";

export function WhitepaperPopup() {
  const { t, localizedPath } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem(STORAGE_KEY);
    if (dismissed) return;

    const timer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    setVisible(false);
    sessionStorage.setItem(STORAGE_KEY, "1");
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={dismiss}>
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />

      {/* Modal */}
      <div
        className="relative bg-background max-w-3xl w-full flex flex-col md:flex-row overflow-hidden animate-fade-up shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Image */}
        <div className="md:w-[45%] h-56 md:h-auto flex-shrink-0">
          <img
            src={whitepaperImg}
            alt="Whitepaper visual"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Content */}
        <div className="flex-1 p-8 md:p-10 flex flex-col justify-center relative">
          <button
            onClick={dismiss}
            className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>

          <p className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
            Whitepaper
          </p>

          <h2 className="text-xl md:text-2xl font-medium tracking-tight leading-snug mb-4">
            {t("popup.whitepaper.headline")}
          </h2>

          <p className="text-sm text-muted-foreground leading-relaxed mb-8">
            {t("popup.whitepaper.subtext")}
          </p>

          <Link
            to={localizedPath("/whitepaper")}
            onClick={dismiss}
            className="inline-flex items-center self-start px-6 py-3 bg-foreground text-background text-xs uppercase tracking-widest font-medium hover:opacity-90 transition-opacity"
          >
            {t("popup.whitepaper.cta")}
          </Link>
        </div>
      </div>
    </div>
  );
}
